export default {
    Window: {
      defaultPosition : {
        xPos: "40px",
        yPos: "25px",
      },
      defaultSize : {
        width: "450px",
        height: "592px",
      },

      // live chat foundation
      rootId: 'nit-alme-window-root',
      standardRootId: 'nit-alme-window-root',
      embeddedRootId: 'ivaSearchEmbed',
    },
};



// WEBPACK FOOTER //
// ./settings/window.ts